import { Box, useStyleConfig } from "@chakra-ui/react";
import React from "react";

const MainPanel = React.forwardRef(function MainPanel(props, ref) {
  const { variant, children, ...rest } = props;
  const styles = useStyleConfig("MainPanel", { variant });
  // Pass the computed styles into the `__css` prop
  return (
    <Box __css={styles} ref={ref} {...rest}>
      {children}
    </Box>
  );
});

export default MainPanel;
